export const BedIcons = {
  twin: require('./A Twin.svg'),
  couch: require('./Couch.svg'),
  full_bed: require('./Full Bedframe.svg'),
  king_bed: require('./King Bedframe.svg'),
  queen_bed: require('./Queen Bedframe.svg'),
  twins: require('./Twins.svg'),
};
